import React from 'react'
import {
  SnackbarProvider as NotistackProvider,
  useSnackbar,
  MaterialDesignContent,
  type SnackbarKey,
} from 'notistack'
import { IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import Close from '@mui/icons-material/Close'

const SnackbarCloseButton = ({ id }: { id: SnackbarKey }) => {
  const { closeSnackbar } = useSnackbar()

  return (
    <IconButton onClick={() => closeSnackbar(id)}>
      <Close htmlColor="#fff" />
    </IconButton>
  )
}

// The app sets `html { font-size: 62.5% }` (so 1rem = 10px) and MUI components
// scale through the theme's `htmlFontSize: 10`. notistack v3 is MUI-independent
// and hardcodes its content font to `0.875rem`, which under the 62.5% base
// renders at ~8.75px — far smaller than the ~14px the MUI-v4-backed notistack v1
// showed. Bump it to 1.4rem (~14px) to preserve the prior size, keeping every
// variant's default colors from MaterialDesignContent.
const StyledSnackbarContent = styled(MaterialDesignContent)({
  '&.notistack-MuiContent': {
    fontSize: '1.4rem',
  },
})

const SNACKBAR_COMPONENTS = {
  default: StyledSnackbarContent,
  success: StyledSnackbarContent,
  error: StyledSnackbarContent,
  warning: StyledSnackbarContent,
  info: StyledSnackbarContent,
}

const SnackBarProvider: React.FC<React.PropsWithChildren> = props => {
  return (
    <NotistackProvider
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      autoHideDuration={5000}
      action={key => <SnackbarCloseButton id={key} />}
      Components={SNACKBAR_COMPONENTS}
    >
      {props.children}
    </NotistackProvider>
  )
}

export default SnackBarProvider
